export const SIDEBAR_COLLAPSED_WIDTH = 64;
export const SIDEBAR_EXPANDED_WIDTH = 280;
export const PIPELINE_SIDEBAR_EXPANDED_WIDTH = 320;
export const SIDEBAR_MAX_EXPANDED_WIDTH = 800;
export const SIDEBAR_MIN_EXPANDED_WIDTH = 200;
